<template>
  <b-button
    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
    variant="flat-secondary"
    class="btn-icon rounded-circle"
    v-b-tooltip.hover.v-secondary.top="$t(i18nHoverVariable)"
    @click="$emit('clicked')"
  >
    <feather-icon icon="EditIcon" />
  </b-button>
</template>

<script>
import Ripple from 'vue-ripple-directive'
import { VBTooltip } from 'bootstrap-vue'

export default {
  name: 'EditButton',
  directives: {
    Ripple,
    'b-tooltip': VBTooltip,
  },
  props: {
    i18nHoverVariable: {
      type: String,
      default: "Edit",
    },
  },
}
</script>

<style scoped>

</style>
